import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentDevolutionCreateAction from './equipmentDevolutionCreate.action.json' with { type: 'json' }
import equipmentDevolutionObject from '../equipmentDevolutionObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'

const equipmentDevolutionCreateDefinition = defineAction({
  ...equipmentDevolutionCreateAction,

  input: equipmentDevolutionObject.pick({
    equipmentId: true,
    loanId: true,
    citizenId: true,
    devolutionDate: true,
    observation: true,
  }),
  output: equipmentDevolutionObject
    .pick({
      id: true,
    })
    .extend({
      protocolId: protocolObject.shape.id,
      protocolCode: protocolObject.shape.code,
    }),
})

export default equipmentDevolutionCreateDefinition
